module.exports = __webpack_public_path__ + "static/WSJ-f5d7a6d0cde458f61504a2e0013844be.svg";